import { RawDraftContentBlock } from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { SerializedSSIAnchorNode, SSIAnchorNode } from 'modules/Lexical/nodes/SSIAnchorNode';

export function createSerializedSSIAnchorNode(contentBlock: RawDraftContentBlock): SerializedSSIAnchorNode {
  return {
    type: SSIAnchorNode.getType(),
    version: 1,
    id: contentBlock.key,
  };
}
